var km = require('keymaster');

km.filter = function (event){
  var target = event.target || event.srcElement;
  var tagName = target ? target.tagName : null;
  var isInput = tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
  if (isInput) return false;
  if (target && target.isContentEditable) return false;
  if (tagName === 'DIV' && (target.contentEditable === 'true')) return false;
  return true;
}

module.exports = km;
